export const DRIVE_HISTORY_TYPE_TRANSPORT = 'TRANSPORT';
export const DRIVE_HISTORY_TYPE_EMPTY_TRANSPORT = 'EMPTY_TRANSPORT';

export const EXPENSE = 'EXPENSE';
export const EXPENSE_UNCLASSIFIED = 'EXPENSE_UNCLASSIFIED';

export const INCOME = 'INCOME';
export const INCOME_UNCLASSIFIED = 'INCOME_UNCLASSIFIED';
